import React from 'react';
import { Box } from '@common-fe/common-fe';

import theme from '@/styles/theme';

import ExpressSetupTopbar from './ExpressSetupTopbar';
import { useCurrentExpressSetup } from './hooks';

interface Props {
  children: React.ReactNode;
  isShimmerHide?: boolean;
  isWizardPage?: boolean;
}

const ExpessSetupWrapper: React.FC<Props> = ({
  children,
  isShimmerHide,
  isWizardPage,
}) => {
  const { data: expressSetupData, isLoading, clearCache } = useCurrentExpressSetup();
  return (
    <Box
      width="100%"
      data-testid="express-setup-wrapper"
      justify="between"
      height="fit-content"
      pad={{ top: expressSetupData?.isAbandoned ? '128px' : '72px'}}
    >
      <Box>
        <ExpressSetupTopbar
          expressSetupData={expressSetupData}
          isLoading={isLoading}
          onClearCache={clearCache}
          isShimmerHide={isShimmerHide}
        />
        <Box width={theme.defaultMinContentWidth} direction={isWizardPage ? 'row' : 'column'} alignSelf="center" justify="between" margin="l">
          {children}
        </Box>
      </Box>
    </Box>
  );
};
export default ExpessSetupWrapper;
